var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h2',[_vm._v("Структурные подразделения")]),_c('subdivisions-table')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }